import { Component, Vue, Prop as prop} from 'nuxt-property-decorator';

@Component({
    components: {
        customImage: require('~/components/common/image/').default,
    },
    props: ['item']
})
export default class OfferComponent extends Vue {

}
